import Tool, { type ToolHandler } from '../Tool';
import type { AssistantToolCall } from 'components/framework/models';
import type Agent from '../../agents/Agent';

/**
 * Handler for WritingAgent::DocumentEditTool
 * Handles document editing operations in the assisted editor
 */
function applyDocumentEditToolCall(
  toolCall: AssistantToolCall,
  agent: Agent
): {
  replaced: boolean;
  currentContent?: string;
} {
  let operationType: any = 'replace_text';
  let fromText = '';
  let toText = '';

  if (toolCall.content?.data) {
    const data = JSON.parse(toolCall.content?.data) as any;
    // TODO: remove data.where once we have migrated all tool calls
    if (data && data.where) {
      operationType = data.where;
    }
    if (data && data.operation_type) {
      operationType = data.operation_type;
    }
    if (data && data.old_text) {
      fromText = data.old_text;
    }
    if (data && data.new_text) {
      toText = data.new_text;
    }
  }

  if (!agent.contexts.assistedEditor) {
    console.warn(
      'WritingAgent::applyDocumentEditToolCall - No assisted editor context available'
    );
    return { replaced: false };
  }

  // Route to appropriate method based on content format
  const editorHtml = agent.contexts.assistedEditor.getEditorHtml();

  if (
    agent.contexts.assistedEditor.updateEditorHtml(
      editorHtml,
      toText,
      fromText,
      operationType
    )
  ) {
    return { replaced: true };
  } else {
    console.warn(
      'WritingAgent::applyDocumentEditToolCall - Failed to update editor with HTML content'
    );
    return { replaced: false, currentContent: editorHtml };
  }
}

const documentEditToolHandler: ToolHandler = {
  beforeApproveToolCall(
    toolCall: AssistantToolCall,
    agent: Agent,
    data?: Record<string, unknown> | string
  ): Record<string, unknown> | undefined {
    return applyDocumentEditToolCall(toolCall, agent);
  },

  unavailable(agent: Agent): boolean {
    return !agent.contexts.assistedEditor;
  },
};

Tool.register('WritingAgent::DocumentEditTool', documentEditToolHandler);
